import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './StructureFilter.scss';

export default function StructureFilterSelectedOptionTitles(props) {
  const { selectedOptionTitles, optionsButtonOnClick } = props;

  if (!selectedOptionTitles) {
    return null;
  }

  const countTitles = selectedOptionTitles.length;
  const resultTitles = countTitles > 3 ? [selectedOptionTitles[0], '...', selectedOptionTitles[countTitles - 1]] : selectedOptionTitles;

  return (
    <ButtonWithIcon
      data-e2e="edit-structure-options"
      type="link"
      size="sm"
      sprite="Edit"
      iconRight
      onClick={optionsButtonOnClick}
      className="structure-filter-options-button-mobile e2e-edit-options"
      title="Click to change options"
      aria-label="Click to change options">
      {resultTitles.map((title) => (
        <span key={title} className="structure-filter-options-button-item rx-border-none">
          {title}
        </span>
      ))}
    </ButtonWithIcon>
  );
}

StructureFilterSelectedOptionTitles.propTypes = {
  selectedOptionTitles: PropTypes.array,
  optionsButtonOnClick: PropTypes.func.isRequired,
};
